<template> 
  <div>   
    <div 
      v-for="(temp,index) in item"
      :key="index"
    >
      <v-card
        flat
        class="my-2"
      >
        <v-row no-gutters>
          <v-col
            cols="3"
            sm="2"
            :class="index === 0 ? 'roundColor' : 'roundColorPrevious'"
          >
            <v-container
              fluid
              fill-height
              :class="temp.win_number ? 'roundColor' : 'roundCloseColor' "
            >
              <v-row
                no-gutters
                class="text-center white--text"
              > 
                <v-col cols="12">
                  <h2>{{ dateConvert(temp.created_at).getDate() }}</h2>
                </v-col>
                <v-col cols="12">
                  <h5>
                    {{ getShortMonth(dateConvert(temp.created_at).getMonth()) }}
                    {{ dateConvert(temp.created_at).getFullYear()+543 }}
                  </h5>
                </v-col>    
              </v-row>   
            </v-container> 
          </v-col> 
          <v-col
            cols="9"
            sm="10"
            class="text-center"
          >
            <v-row no-gutters>
              <v-col
                cols="12"
                md="4"
              >
                <v-col cols="12">
                  <b class="grey--text">{{ $t('lotto-type.four') }}</b>
                </v-col>
                <v-col cols="12">
                  <b :class="index===0? 'orange--text' : ''">{{ temp.four }}</b>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-col cols="12">
                  <b class="grey--text">{{ $t('lotto-type.three-up') }}</b>
                </v-col>
                <v-col cols="12">
                  <b :class="index===0? 'orange--text' : ''">{{ temp.three_up }}</b>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-col cols="12">
                  <b class="grey--text">{{ $t('lotto-type.two-down') }}</b>
                </v-col>
                <v-col cols="12">
                  <b :class="index===0? 'orange--text' : ''">{{ temp.two_down }}</b>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div> 
  </div>
</template>
<script>
import { dateConvert, getShortMonth } from '@/plugins/time'
export default {   
  props : {
    item : {
      type : Array,
      default : ()=>[]
    },
    lottoName : {
      type : String,
      default : ''
    }
  },
  methods : { 
    dateConvert,
    getShortMonth,
    roundNumber (temp) {  
      return temp.split(' ').slice(-1)[0]   
    }
  }, 
}
</script>
<style scoped>
.roundColor {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px; 
  background-color: var(--bg-secondary-color); 
}
.roundColorPrevious { 
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px; 
  background-color: var(--bg-main-color); 
}  
</style>